const linkProvider = ({
	href = "",
	injectElement = true,
	disabled = false,
} = {}) => {
	const attributes = {};
	if (disabled) return attributes;
	if (injectElement) {
		attributes.Element = "a";
	}
	attributes.href = href;
	attributes.target = "_blank";
	attributes.rel = "noopener noreferrer";
	return attributes;
};

export default linkProvider;
